import { render, staticRenderFns } from "./MdFile.vue?vue&type=template&id=45fdc23a&scoped=true&"
import script from "./MdFile.vue?vue&type=script&lang=js&"
export * from "./MdFile.vue?vue&type=script&lang=js&"
import style0 from "./MdFile.vue?vue&type=style&index=0&id=45fdc23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fdc23a",
  null
  
)

export default component.exports